export const KEYCHAIN_CONTEXT = "keychain";

export const KEYCHAIN_STORAGE_VERSION = "0.3";
